<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const translationTips = [
  "Sense-for-sense translation karo, word-for-word nahi.",
  "Tense aur pronoun consistency maintain karo.",
  "Simple English choose karo; over-fancy vocabulary ki zarurat nahi hoti.",
];

const practiceHints = [
  "Pehle Urdu sentence ka core sense samjho.",
  "Difficult idiomatic phrase ko simple English me convert karo.",
  "Final draft me grammar aur punctuation recheck karo.",
];

const commonTranslationIssues = [
  "Urdu word order ko bilkul same rakhna unnatural English bana deta hai.",
  "Article use na karna ya wrong article lagana common mistake hai.",
  "Singular/plural mismatch translation ko weak karta hai.",
];

const miniExamples = [
  "Urdu: Mujhe apne mulk se mohabbat hai. / English: I love my country.",
  "Urdu: Mehnat kamyabi ki kunji hai. / English: Hard work is the key to success.",
];

usePageSeo({
  title: "11th Class English Translation | Urdu to English Strategy and Practice",
  description: "11th class English translation page with Urdu to English translation strategy, mini examples, common issues and exam tips.",
  keywords: "11th class english translation, class 11 urdu to english translation, english translation notes, translation practice",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Grammar", item: "/11th/english/grammar/" },
    { name: "Translation", item: "/11th/english/grammar/translation/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Grammar Task"
      title="Translation"
      description="Yeh page Urdu-to-English translation ke liye direct exam strategy deta hai. Focus natural English aur clear sentence sense par hai."
    />

    <EnglishSection title="Translation Tips" description="Use these as the base rules before translating any sentence.">
      <EnglishGrid>
        <EnglishCard v-for="item in translationTips" :key="item" title="Tip" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Practice Hints" description="These help while converting Urdu ideas into natural English.">
      <EnglishGrid>
        <EnglishCard v-for="item in practiceHints" :key="item" title="Practice Hint" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Mini Translation Examples" description="A few compact examples to show the expected style.">
      <EnglishGrid>
        <EnglishCard v-for="item in miniExamples" :key="item" title="Example" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Issues" description="Avoid these if you want the translated sentence to stay natural and correct.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonTranslationIssues" :key="item" title="Issue" :description="item" />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
